export default function closest(el, s) {
  if (!document.documentElement.contains(el)) return null;
  do {
    if (el.matches(s)) return el;
    el = el.parentElement || el.parentNode; // eslint-disable-line
  } while (el !== null && el.nodeType === 1);
  return null;
}
